import { createEntityAdapter, EntityAdapter } from '@ngrx/entity'
import { ChangeItem } from '../../model/change-item.model'

export const ChangeItemAdapter: EntityAdapter<ChangeItem> = createEntityAdapter<ChangeItem>({
  selectId: (changeItem: ChangeItem) => changeItem.identity,
})
